const getBASE_URL = () => {
    return process.env.REACT_APP_ENV_NAME === 'main' ? "https://api.sogonfit.com" : "https://api.sogonfit.l-league.co.kr" 
    // return "https://api.sogonfit.l-league.co.kr";
}; 

export const BASE_URL = getBASE_URL();